/* eslint-disable @typescript-eslint/naming-convention */
import { useOutletContext, useParams } from 'react-router-dom'
import { useComputed, useSignal } from '@preact/signals-react'

import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Table from 'react-bootstrap/Table'

import AddRolesBusinessEntityLeaf from '../../components/AddRolesBusinessEntityLeaf.jsx'
import Loadable from '../../../../components/Loadable.jsx'

import { addGroupRoleBusinessEntity, fetchGroupRoleBusinessEntities } from '../../../../state/actions/groupActions.js'
import { addNotification, NotificationTypes } from '../../../../state/actions/notificationActions.js'
import { fetchOrganizationRoleList } from '../../../../state/actions/roleActions.js'

import { organizationRoleListSignal, organizationRoleListLoadedSignal, organizationRoleListErrorSignal, organizationRoleDictionarySignal, roleBusinessEntitiesLoadedSignal, roleBusinessEntitiesErrorSignal } from '../../../../state/signals/roleSignals.js'

import { isEmptyObject } from '../../../../utils/utils.js'

const AddGroupRolesModal = ({ showSignal, parentBusinessEntity }) => {

	const { beId, groupId } = useParams()
	const { user, config, accessToken, userPermissions, userPermissionsSummary, accordionData } = useOutletContext()

	const selectedOrganizationsSignal = useSignal(new Set())
	const selectedRoleIdSignal = useSignal(null)
	const editDisabledSignal = useSignal(false)

	const enableAddRoleSignal = useSignal(false)

	const RoleSelectOptions = ({ roles }) => {
		//console.log("Roles for this organization:")
		//console.log(roles)
		let options = []
		for(let i = 0; i < roles.length; i++){
			const content = roles[i]
			options.push(
				<option key={content.id} value={content.id}>
					{content.name}
				</option>
			)
		}
		return options
	}

	const addRole = (event) => {
		event.preventDefault()
		organizationRoleListLoadedSignal.value = false
		roleBusinessEntitiesLoadedSignal.value = false
		const roleId = selectedRoleIdSignal.value
		const entity = {
			businessEntityIds: Array.from(selectedOrganizationsSignal.value),
			groupId: groupId,
			lastUpdatedAt: "",
			roleId: roleId
		}
		addGroupRoleBusinessEntity(beId, groupId, entity, config, accessToken).then(
			(groupRoleBusinessEntity) => {
				fetchOrganizationRoleList(beId, config, accessToken, true).then(
					(organizationRoleList) => {
						fetchGroupRoleBusinessEntities(beId, groupId, config, accessToken, true).then(
							(groupRoleBusinessEntities) => {
								const role = organizationRoleDictionarySignal.value[roleId]
								addNotification(`Successfully added new role "${role.name}"`, NotificationTypes.SUCCESS, true, "Added Role")
							}
						)
					}
				)
			}
		)
		closeModal()
	}

	const closeModal = () => {
		showSignal.value = false
		selectedRoleIdSignal.value = null
		enableAddRoleSignal.value = false
		selectedOrganizationsSignal.value = new Set()
	}

	if (!groupId) {
		window.alert("Group ID is undefined in AddGroupRolesModal")
		return null
	}

	return (
		<Modal show={showSignal.value} onHide={closeModal}>
			<Modal.Header closeButton>
				<Modal.Title>Add Role</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<label>Choose Role</label>
				<Loadable loadedSignals={[organizationRoleListLoadedSignal]} errorSignals={[organizationRoleListErrorSignal]}>
					<select 
						name='userAddRolesRoleSelector' 
						id='userAddRolesRoleSelector' 
						className='form-control' 
						onChange={
							(event) => {
								selectedRoleIdSignal.value = event.target.value
								console.log("Selected role ID:")
								console.log(selectedRoleIdSignal.value)
							}
						}
						disabled={editDisabledSignal.value ? "disabled" : undefined} 
						required={true}
						value={selectedRoleIdSignal.value ? selectedRoleIdSignal.value : undefined}
					>
						<option value=''>Select Role</option>
						<RoleSelectOptions roles={organizationRoleListSignal.value}></RoleSelectOptions>
					</select>
				</Loadable>
				<label>Choose Accounts</label>
				<div style={{ maxHeight: "400px", overflowY: "auto" }} >
					<Table id='groupParentOrg' className='table table-hover'>
						<thead></thead>
						<tbody style={{ maxHeight: "180px" }} >{
							selectedRoleIdSignal.value ? (
								<AddRolesBusinessEntityLeaf 
									childOrg={parentBusinessEntity}
									selectedRoleIdSignal={selectedRoleIdSignal}
									selectedOrganizationsSignal={selectedOrganizationsSignal}
									enableAddRoleSignal={enableAddRoleSignal}
								></AddRolesBusinessEntityLeaf>
							) : (
								<tr>
									<td colSpan='2' className='empty-record'>
										To begin, please select a role from above.
									</td>
								</tr>
							)
						}</tbody>
					</Table>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<span id="errors" style={{color:"red", float:"left"}}></span>
				<Button className="btn btn-default" onClick={closeModal}>Cancel</Button>
				<Button className="btn btn-primary" onClick={addRole} disabled={enableAddRoleSignal.value == false}>Add</Button>
			</Modal.Footer>
		</Modal>
	)
}
export default AddGroupRolesModal